import { ISection } from "../types/recommended-loans-types.types";
import { API_PATHS } from "../constants/api-paths";
import { IResponse, request } from "../core/api.client";

export interface IRecommendedResponse {
  [key: string]: ISection[];
}

interface IRecommendedParams {
  category?: string;
  clpSectionName?: string[];
  page?: string;
  subClpSectionName?: string[];
  webFlag?: string;
  locale?: string;
}

const getRecommendedLoansApi = async ({
  category,
  clpSectionName,
  page,
  subClpSectionName,
  locale,
}: IRecommendedParams): Promise<IResponse<IRecommendedResponse>> => {
  try {
    const response = await request<IRecommendedResponse, IRecommendedParams>({
      method: "POST",
      url: API_PATHS.recommended,
      data: {
        category,
        clpSectionName,
        page,
        subClpSectionName,
        webFlag: "Yes",
        locale,
      },
    });
    if (response.statusCode !== 90) throw response.message;
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default getRecommendedLoansApi;
